import React from 'react'

import { Button, TextField } from '@octane/spark'
import { DealershipInfo } from 'state/user/UserState'

import {
    InputTitle,
    RowInput,
    RowSubtitle,
    SectionPrequal,
    Subtitle,
    Title,
} from './Flexlink.styled'
import { onCopyLink, useDownloadKit } from './flexLinkHandlers'

export * from './flexLinkHandlers'

export default function FlexLink({
    dealership,
    flexLink,
}: Readonly<{
    dealership?: DealershipInfo
    flexLink?: string
}>): JSX.Element | null {
    const { downloading, downloadKit } = useDownloadKit()

    if (!flexLink || !dealership) return null

    return (
        <SectionPrequal data-testid="section-prequal">
            <div className="column">
                <Title>Prequal Flex: Prequalify customers anywhere</Title>
                <RowSubtitle>
                    <Subtitle>
                        QR Codes • Templates & In-store Materials
                    </Subtitle>
                    <Button
                        onClick={() => downloadKit(dealership)}
                        loading={downloading}
                        size="small"
                    >
                        {downloading
                            ? 'Downloading your kit…'
                            : 'Download your kit'}
                    </Button>
                </RowSubtitle>
            </div>
            <div className="separator" />
            <div className="column">
                <InputTitle>USE YOUR PREQUAL FLEX LINK</InputTitle>
                <RowInput>
                    <TextField
                        data-testid="flex-link-input"
                        defaultValue={flexLink}
                        id="flex-link-input"
                        onChange={() => undefined}
                        readOnly
                        type="text"
                        value={flexLink}
                    />
                    <Button onClick={() => onCopyLink(flexLink)}>
                        Copy Your Prequal Flex Link
                    </Button>
                </RowInput>
            </div>
        </SectionPrequal>
    )
}
